import type { IRelationshipManager } from '../application';

export enum CustomerBaseType {
    COMPANY = 'COMPANY',
    PRIVATE = 'PRIVATE',
}

export interface ICustomerBase {
    isSource?: boolean;
    externalId: string;
    displayName: string;
    type: CustomerBaseType;
    permissions: string[];
    relationshipManagerId: string;
    relationshipManager?: IRelationshipManager;
    vtlnr?: string;
}
